export default class RecordController
{
	constructor($scope, $http, DTOptionsBuilder, DTColumnBuilder) {
		// Dependancies
		this.$scope = $scope;
		this.$http = $http;
		this.$scope.$parent.title = 'View records';
		this.$scope.$parent.endpoint = 'records';

		this.rows = [];
		this.offset = 0;
		this.limit = 100;

		this.dtOptions = DTOptionsBuilder.newOptions()
		// .withDOM('pitrfl')
        .withOption('bProcessing', true)
        .withOption('bServerSide', true)
        .withOption('sAjaxSource', '/api/records')
		.withOption('aaSorting', [1, 'desc'])
		.withOption('aLengthMenu', [25, 50, 100, 250])
		.withDisplayLength(50);

		this.dtColumns = [
			DTColumnBuilder.newColumn('id').withTitle('ID'),
			DTColumnBuilder.newColumn('date_visited').withTitle('Date visited'),
			DTColumnBuilder.newColumn('volume').withTitle('Volume'),
			DTColumnBuilder.newColumn('visitor_type').withTitle('Type'),
			DTColumnBuilder.newColumn('visitor_origin').withTitle('Origin'),
			DTColumnBuilder.newColumn('country_iso').withTitle('Country'),
			DTColumnBuilder.newColumn('postcode').withTitle('Postcode'),
			DTColumnBuilder.newColumn('organisation_name').withTitle('Organisation'),
			DTColumnBuilder.newColumn('accommodation_name').withTitle('Accommodation'),
			DTColumnBuilder.newColumn('transport_type_name').withTitle('Transport'),
			DTColumnBuilder.newColumn('airline_name').withTitle('Airline'),
			DTColumnBuilder.newColumn('referral_type_name').withTitle('Referral'),
			DTColumnBuilder.newColumn('advertising_type_name').withTitle('Advertising'),
			DTColumnBuilder.newColumn('creator').withTitle('Creator'),
			DTColumnBuilder.newColumn(null).withTitle('Actions')
				.notSortable()
	            .renderWith(function(data, type, full, meta) {
	                return '<a href="/#/records/'+data.id+'/edit"><i class="fa fa-edit"></i>';
	            })
		];

		this.dtInstance = {};

	}
}



/** WEBPACK FOOTER **
 ** ./resources/assets/js/controllers/records/record.controller.js
 **/